import axios from "axios";
import { getApiBaseUrl } from "./baseUrl";

const api = axios.create({ baseURL: getApiBaseUrl() });

// 요청마다 토큰 자동 주입
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 응답 시 전역 로그아웃 이벤트 발행
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      window.dispatchEvent(new Event("auth:logout"));
    }
    return Promise.reject(err);
  }
);

// ── 인증 API ──────────────────────────────────────────────────────────────────
export const authApi = {
  login: (password) => api.post("/auth/login", { password }),
};

// ── 블로그 API ────────────────────────────────────────────────────────────────
export const blogApi = {
  getList: ({ search = "", tag = "", page = 1, limit = 10 } = {}) =>
    api.get("/blog", { params: { search, tag, page, limit } }),

  getOne: (id) => api.get(`/blog/${id}`),

  // ✅ 별도 엔드포인트 없이 getOne 재사용 — 조회수는 increaseView로 분리했으므로 문제 없음
  getForEdit: (id) => api.get(`/blog/edit/${id}`),

  getTags: () => api.get("/blog/tags"),

  create: (data) => api.post("/blog", data),

  update: (id, data) => api.put(`/blog/${id}`, data),

  remove: (id) => api.delete(`/blog/${id}`),

  increaseView: (id) => api.post(`/blog/${id}/view`),

  uploadImage: (file, onProgress) => {
    const form = new FormData();
    form.append("image", file);
    return api.post("/blog/upload", form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded * 100) / e.total));
        }
      },
    });
  },

  deleteImage: (key) => api.delete(`/blog/upload/${key}`),
};
